import { Fragment } from "react";
import ProgressBar from "../../charts/progress/ProgressBar";
import { getBudgetOverallColor } from "../../charts/utils/dynamicColorsBar";
import Tooltip from "../../Tooltip";
import FiInsightCard from "../../../../pages/private/financial-insights/common/FiInsightCard";
import PillFilter from "../../filters/PillFilter";

// Frequency Filter Options Constant (or pass as props)
const FREQUENCY_OPTIONS = [
  { label: "All", value: "ALL" },
  { label: "Weekly", value: "WEEKLY" },
  { label: "Monthly", value: "MONTHLY" },
];

function OverallBudgetCard({
  spent,
  limit,
  percentage,
  hasNoBudgets,
  onCreateBudgetClick,
  copy,
  // New props for UI filter state
  selectedFrequency = "ALL",
  onFrequencyChange,
}) {
  const threshold = 90;
  const dynamicColor = getBudgetOverallColor(spent, limit, threshold);
  const spentAmount = `$${(Number(spent) || 0).toFixed(2)}`;

  return (
    <Fragment>
      <div
        className="budget-overall-usage-container mobile-reset-standard-card-container"
        style={{ marginBottom: "24px" }}
      >
        <div className="bou-header col-layout">
          {/* Always show the Title Header */}
          <div className="raw-layout bou-header-meta">
            <div className="col-layout bou-header-meta-desc">
              <h4 className="margin-reset">{copy?.title}</h4>
              {!hasNoBudgets && (
                <span>
                  {copy?.summary
                    ?.replace("{spent}", spent)
                    .replace("{limit}", limit)}
                </span>
              )}
            </div>

            {!hasNoBudgets && (
              <div className="bou-header-filter-container">
                <PillFilter
                  className="budgets-frequency-filter"
                  options={FREQUENCY_OPTIONS}
                  activeValue={selectedFrequency}
                  onChange={onFrequencyChange}
                />
              </div>
            )}
          </div>

          {/* Conditional Rendering: If NO budgets exist, ONLY show the insight card */}
          {hasNoBudgets ? (
            <FiInsightCard title={copy?.empty_insight?.title}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                  marginTop: "8px",
                }}
              >
                <p className="insight-item reset-margin">
                  <span>{copy?.empty_insight?.description}</span>
                </p>
                <div>
                  <button
                    className="cta-button primary rounded small"
                    onClick={onCreateBudgetClick}
                    style={{ width: "fit-content" }}
                  >
                    {copy?.empty_insight?.cta}
                  </button>
                </div>
              </div>
            </FiInsightCard>
          ) : (
            /* Standard Full UI: Only shows when budgets are present */
            <Fragment>
              <div className="bou-header-progress">
                <ProgressBar
                  spent={spent}
                  total={limit}
                  threshold={threshold}
                  percentage={percentage}
                  getColor={getBudgetOverallColor}
                />
              </div>

              <div className="bou-header-statistics">
                <div className="bou-header-statistics-card">
                  <span className="bou-statistics-card-heading">
                    {copy?.stats?.total_limit}
                  </span>
                  <Tooltip
                    title={copy?.stats?.total_limit_tooltip_title}
                    content={copy?.stats?.total_limit_tooltip_description}
                  >
                    <span
                      className="bou-statistics-card-amount"
                      style={{
                        color: "#001d38",
                        borderBottom: "1px dashed #A3AED0",
                        cursor: "pointer",
                      }}
                    >
                      ${(Number(limit) || 0).toFixed(2)}
                    </span>
                  </Tooltip>
                </div>
                <div className="bou-header-statistics-card">
                  <span className="bou-statistics-card-heading">
                    {copy?.stats?.remaining}
                  </span>
                  <Tooltip
                    title={copy?.stats?.remaining_tooltip_title}
                    content={copy?.stats?.remaining_tooltip_description}
                  >
                    <span
                      className="bou-statistics-card-amount"
                      style={{
                        borderBottom: "1px dashed #A3AED0",
                        cursor: "pointer",
                      }}
                    >
                      ${(Number(limit - spent) || 0).toFixed(2)}
                    </span>
                  </Tooltip>
                </div>
                <div className="bou-header-statistics-card">
                  <span className="bou-statistics-card-heading">
                    {copy?.stats?.spent}
                  </span>
                  <Tooltip
                    title={copy?.stats?.spent_tooltip_title}
                    content={copy?.stats?.spent_tooltip_description?.replace(
                      "{spent_amount}",
                      spentAmount,
                    )}
                  >
                    <span
                      className="bou-statistics-card-amount"
                      style={{
                        color: dynamicColor,
                        borderBottom: `1px dashed ${dynamicColor}`,
                        cursor: "pointer",
                      }}
                    >
                      {spentAmount}
                    </span>
                  </Tooltip>
                </div>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  );
}

export default OverallBudgetCard;
